import { useState } from "react"
import { Box, Badge, Chip, Paper, Stack, Typography } from "@mui/material"
import SimilarSkill from "./SimilarSkill"
import useTranslationSharie from "../hooks/Language/useTranslation"

const FavoriteSkills = ({ skills = [] }) => {
  const [selected_skill, setSelectedSkills] = useState(null) // Store similar skills from API
  const t = useTranslationSharie()

  const handleSkillClick = (skill) => {
    if (skill === selected_skill) setSelectedSkills(null) // Deselect if already selected
    else setSelectedSkills(skill) // Set the selected skill
  }

  return (
    <Paper
      elevation={4}
      sx={{
        p: 3,
        borderRadius: "0.8rem",
        width: "100%", // Set full width of the parent container
        mx: "auto", // Center horizontally
        mt: 4,
        m: 4,
        overflow: "hidden", // Prevents overflow if content exceeds width
        position: "relative", // Needed for the minimize icon to position correctly
      }}
    >
      <Stack alignItems={"center"} direction='row' spacing={1} flexWrap='wrap'>
        <Typography variant='body2' color='text.secondary' sx={{ padding: "1rem" }}>
          {t("Favorite Skills")}
        </Typography>
        {skills.map((skill) => (
          <Badge
            key={skill.name}
            badgeContent={skill.likes_count} // Number of likes
            color='error' // Red badge color
            overlap='circular' // Keeps badge within chip
            sx={{
              "& .MuiBadge-badge": {
                fontSize: "12px",
                fontWeight: "bold",
                minWidth: "20px",
                height: "20px",
                borderRadius: "50%",
                padding: "0 6px",
                marginLeft: "15px",
              },
            }}
          >
            <Chip
              label={skill.name}
              color='primary'
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                p: 0.5,
                cursor: "pointer",
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={() => handleSkillClick(skill)}
            />
          </Badge>
        ))}
      </Stack>

      {selected_skill && (
        <Box sx={{ mt: 2 }}>
          <SimilarSkill skill={selected_skill} key={selected_skill?.name} />
        </Box>
      )}
    </Paper>
  )
}

export default FavoriteSkills
